import { formatDate } from 'common'
import { getPSTTimeOffset } from './getPSTTimeOffset'

export const todaysPSTDateString = () => {
  const pstTimezoneOffset = getPSTTimeOffset()
  return formatDate(new Date(new Date().getTime() + pstTimezoneOffset))
}
